import {
  CHANGE_BACKUP_INFO,
    CHANGE_EMAIL_SERVER_INFO,
    CHANGE_MADRID_PDF_ERROR_INFO,
    GET_BACKUP_INFO,
    GET_BACKUP_INFO_SUCCESS,
    GET_DB_CAPACITY_INFO,
    GET_DB_CAPACITY_INFO_SUCCESS,
    GET_EMAIL_SERVER_INFO,
    GET_EMAIL_SERVER_INFO_SUCCESS,
    GET_HAGUE_CRAWL_INFO,
    GET_HAGUE_CRAWL_INFO_SUCCESS,
    GET_MADRID_CRAWL_INFO,
    GET_MADRID_CRAWL_INFO_SUCCESS,
    GET_MADRID_DISCREPENCY_INFO,
    GET_MADRID_DISCREPENCY_INFO_SUCCESS,
    GET_MADRID_PDF_ERROR_INFO,
    GET_MADRID_PDF_ERROR_INFO_SUCCESS,
    GET_PCT_CRAWL_INFO,
    GET_PCT_CRAWL_INFO_SUCCESS,
    GET_REMAINING_INFO,
    GET_REMAINING_INFO_SUCCESS,
    GET_ROMARIAN_INFO,
    GET_ROMARIAN_INFO_SUCCESS,
    GET_SERVERS_INFO,
    GET_SERVERS_INFO_SUCCESS,
    SAVE_BACKUP_INFO,
    SAVE_BACKUP_INFO_SUCCESS,
    SAVE_EMAIL_SERVER_INFO,
    SAVE_EMAIL_SERVER_INFO_SUCCESS,
    SAVE_MADRID_PDF_ERROR_INFO,
    SAVE_MADRID_PDF_ERROR_INFO_SUCCESS,
    SET_ADM_DATA_MANAGEMENT_ERROR,
    SET_ADM_DATA_MANAGEMENT_LOADING,
    SET_ADM_DATA_MANAGEMENT_RESULT,
    SET_ADM_DATA_MANAGEMENT_SUCCESS
} from "./actionTypes"

export const setAdmDataManagementLoading = data => {
    return {
        type: SET_ADM_DATA_MANAGEMENT_LOADING,
        payload: data,
    }
}

export const setAdmDataManagementError = data => {
    return {
        type: SET_ADM_DATA_MANAGEMENT_ERROR,
        payload: data,
    }
}

export const setAdmDataManagementSuccess = data => {
    return {
        type: SET_ADM_DATA_MANAGEMENT_SUCCESS,
        payload: data,
    }
}

export const setAdmDataManagementResult = data => {
    return {
        type: SET_ADM_DATA_MANAGEMENT_RESULT,
        payload: data,
    }
}

export const getDbCapacityInfoList = data => {
  return {
    type: GET_DB_CAPACITY_INFO,
    payload: data,
  }
}

export const getDbCapacityInfoListSuccess = data => {
  return {
    type: GET_DB_CAPACITY_INFO_SUCCESS,
    payload: data,
  }
}

export const getMadridCrawlInfoList = data => {
  return {
    type: GET_MADRID_CRAWL_INFO,
    payload: data,
  }
}

export const getMadridCrawlInfoListSuccess = data => {
  return {
    type: GET_MADRID_CRAWL_INFO_SUCCESS,
    payload: data,
  }
}

export const getHagueCrawlInfoList = data => {
  return {
    type: GET_HAGUE_CRAWL_INFO,
    payload: data,
  }
}

export const getHagueCrawlInfoListSuccess = data => {
  return {
    type: GET_HAGUE_CRAWL_INFO_SUCCESS,
    payload: data,
  }
}

export const getPctCrawlInfoList = data => {
  return {
    type: GET_PCT_CRAWL_INFO,
    payload: data,
  }
}

export const getPctCrawlInfoListSuccess = data => {
  return {
    type: GET_PCT_CRAWL_INFO_SUCCESS,
    payload: data,
  }
}

export const getMadridPdfErrorInfoList = data => {
  return {
    type: GET_MADRID_PDF_ERROR_INFO,
    payload: data,
  }
}

export const getMadridPdfErrorInfoListSuccess = data => {
  return {
    type: GET_MADRID_PDF_ERROR_INFO_SUCCESS,
    payload: data,
  }
}

export const changePdfErrorInfoList = data => {
  return {
    type: CHANGE_MADRID_PDF_ERROR_INFO,
    payload: data,
  }
}

export const savePdfErrorInfoList = data => {
  return {
    type: SAVE_MADRID_PDF_ERROR_INFO,
    payload: data,
  }
}

export const savePdfErrorInfoListSuccess = data => {
  return {
    type: SAVE_MADRID_PDF_ERROR_INFO_SUCCESS,
    payload: data,
  }
}

export const getMadridDiscrepencyInfoList = data => {
  return {
    type: GET_MADRID_DISCREPENCY_INFO,
    payload: data,
  }
}

export const getMadridDiscrepencyInfoListSuccess = data => {
  return {
    type: GET_MADRID_DISCREPENCY_INFO_SUCCESS,
    payload: data,
  }
}

export const getServersInfoList = data => {
  return {
    type: GET_SERVERS_INFO,
    payload: data,
  }
}

export const getServersInfoListSuccess = data => {
  return {
    type: GET_SERVERS_INFO_SUCCESS,
    payload: data,
  }
}

export const getEmailServerInfoList = data => {
  return {
    type: GET_EMAIL_SERVER_INFO,
    payload: data,
  }
}

export const getEmailServerInfoListSuccess = data => {
  return {
    type: GET_EMAIL_SERVER_INFO_SUCCESS,
    payload: data,
  }
}

export const changeEmailServerInfoList = data => {
  return {
    type: CHANGE_EMAIL_SERVER_INFO,
    payload: data,
  }
}

export const saveEmailServerInfoList = data => {
  return {
    type: SAVE_EMAIL_SERVER_INFO,
    payload: data,
  }
}

export const saveEmailServerInfoListSuccess = data => {
  return {
    type: SAVE_EMAIL_SERVER_INFO_SUCCESS,
    payload: data,
  }
}

export const getBackupInfoList = data => {
  return {
    type: GET_BACKUP_INFO,
    payload: data,
  }
}

export const getBackupInfoListSuccess = data => {
  return {
    type: GET_BACKUP_INFO_SUCCESS,
    payload: data,
  }
}

export const changeBackupInfoList = data => {
  return {
    type: CHANGE_BACKUP_INFO,
    payload: data,
  }
}

export const saveBackupInfoList = data => {
  return {
    type: SAVE_BACKUP_INFO,
    payload: data,
  }
}

export const saveBackupInfoListSuccess = data => {
  return {
    type: SAVE_BACKUP_INFO_SUCCESS,
    payload: data,
  }
}

export const getRemainingInfoList = data => {
  return {
    type: GET_REMAINING_INFO,
    payload: data,
  }
}

export const getRemainingInfoListSuccess = data => {
  return {
    type: GET_REMAINING_INFO_SUCCESS,
    payload: data,
  }
}

export const getRomarianInfoList = data => {
  return {
    type: GET_ROMARIAN_INFO,
    payload: data,
  }
}

export const getRomarianInfoListSuccess = data => {
  return {
    type: GET_ROMARIAN_INFO_SUCCESS,
    payload: data,
  }
}
